import { z } from 'zod'

export const createTagSchema = z.object({
  name: z.string().trim().min(1, { message: 'タグ名を入力してください' }),
  color: z.string().min(1),
})

export type CreateTagInput = z.infer<typeof createTagSchema>
